if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const mainPdpQty = formData.get("quantity") || 1;
        const randomNo = Date.now();;

          const hasEmbroidery = document.querySelector('.Embroidery_block_feilds') !== null;

        let leftIndex = 1;
        let rightIndex = 4;

        let variantKey = '0/0';

        if (hasEmbroidery) {
          const leftinput01El = document.getElementById('0-1-line');
          const leftinput02El = document.getElementById('0-2-line');
          const leftinput03El = document.getElementById('0-3-line');

          const rightinput01El = document.getElementById('1-1-line');
          const rightinput02El = document.getElementById('1-2-line');
          const rightinput03El = document.getElementById('1-3-line');

          const leftinput01 = leftinput01El ? leftinput01El.value : '';
          const leftinput02 = leftinput02El ? leftinput02El.value : '';
          const leftinput03 = leftinput03El ? leftinput03El.value : '';

          const rightinput01 = rightinput01El ? rightinput01El.value : '';
          const rightinput02 = rightinput02El ? rightinput02El.value : '';
          const rightinput03 = rightinput03El ? rightinput03El.value : '';

          if (typeof window.variantData === 'undefined') {
            console.error('Variant data is not available. Ensure the first script has been loaded.');
            return;
          }

          let leftFilled = 0;
          let rightFilled = 0;

          if (leftinput01.trim() !== '') leftFilled = 1;
          if (leftinput02.trim() !== '') leftFilled = 2;
          if (leftinput03.trim() !== '') leftFilled = 3;

          if (rightinput01.trim() !== '') rightFilled = 1;
          if (rightinput02.trim() !== '') rightFilled = 2;
          if (rightinput03.trim() !== '') rightFilled = 3;

          variantKey = `${leftFilled}/${rightFilled}`.replace(/\s+/g, '');

          // if no addon selected (both sides empty), skip addon lookup and appending
          if (variantKey === '0/0') {
            console.log('No addon selected (variantKey 0/0) - skipping addon item');
          } else {
            let matchingVariant = window.variantData.find(variant =>
              variant.variantTitle.replace(/\s+/g, '') === variantKey
            );
            if (matchingVariant) {
              formData.append(`items[${leftIndex}][id]`, matchingVariant.variantId);
  
                formData.append(`items[${leftIndex}][quantity]`, mainPdpQty);
              formData.append(`items[${leftIndex}][properties][_bundle]`, randomNo);
              leftIndex++;

              console.log('Variant selected:', matchingVariant);
            } else {
              console.error('Variant not found for key:', variantKey);
            }
          }
        } else {
          console.log('Embroidery fields not present — skipping addon logic');
        }

        console.log('Filled:', variantKey);



          const mainVrarientId = formData.get('id');
          const mainQy = formData.get('quantity') || 1;
          const mainProperties = {};
          for (const [key, value] of formData.entries()) {
            const propMatch = key.match(/^properties\[(.+)\]$/);
            if (propMatch) {
              mainProperties[propMatch[1]] = value;
            }
          }

          formData.delete('id');
          formData.delete('quantity');
          for (const propName in mainProperties) {
            formData.delete(`properties[${propName}]`);
          }

          formData.append(`items[0][id]`, mainVrarientId);
          formData.append(`items[0][quantity]`, mainQy);
          for (const propName in mainProperties) {
            formData.append(`items[0][properties][${propName}]`, mainProperties[propName]);
          }
          formData.append(`items[0][properties][_bundle]`, randomNo);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
